export default __webpack_public_path__ + "static/media/header-back.f48dcf18.jpg";